module.exports = __webpack_public_path__ + "img/3_sp.e49beab2.gif";